export const updateKeyValueInFragment = ({
  store,
  id,
  fragment,
  fragmentName,
  key,
  value,
}) => {
  const frag = {
    id,
    fragment,
    fragmentName,
  }
  let obj
  try {
    obj = store.readFragment(frag)
  } catch (err) {}
  if (obj && obj[key] !== undefined && value !== undefined) {
    const data = {
      ...obj,
      [key]: value,
    }
    store.writeFragment({
      ...frag,
      data,
    })
  }
}

export function addItemToFragmentList({
  store,
  id,
  fragment,
  fragmentName,
  item,
  key,
  transformFunc,
}) {
  const frag = {
    id,
    fragment,
    fragmentName,
  }
  let obj
  try {
    obj = store.readFragment(frag)
  } catch (err) {}
  if (obj && obj[key] !== undefined) {
    // new object
    // check that object doesn't already exist in list
    // check if primitive or object with _id
    if (
      obj[key] &&
      (obj[key].includes(item) ||
        (item._id && obj[key].map((it) => it._id).includes(item._id)))
    ) {
      return
    }
    const data = {
      ...obj,
      [key]: [...obj[key], item],
    }
    store.writeFragment({
      ...frag,
      data,
    })
    // any additional transformations on data
    // used to get center of new list of features in area (as one application)
    if (transformFunc) {
      store.writeFragment({
        ...frag,
        data: transformFunc(data),
      })
    }
  }
}

export const removeItemFromFragmentList = ({
  store,
  id,
  fragment,
  fragmentName,
  itemId,
  key,
  transformFunc,
}) => {
  const frag = {
    id,
    fragment,
    fragmentName,
  }
  let obj
  try {
    obj = store.readFragment(frag)
  } catch (err) {}
  if (obj && obj[key] !== undefined) {
    // new object
    const data = {
      ...obj,
      [key]: obj[key].filter((item) => item._id !== itemId),
    }
    store.writeFragment({
      ...frag,
      data,
    })
    // any additional transformations on data
    // used to get center of new list of features in area (as one application)
    if (transformFunc) {
      store.writeFragment({
        ...frag,
        data: transformFunc(data),
      })
    }
  }
}

export default {
  updateKeyValueInFragment,
  addItemToFragmentList,
  removeItemFromFragmentList,
}
